import { Factory } from 'miragejs';

import { assert } from '@qonto/mirage/utils/assert';

export default Factory.extend({
  amount: {
    value: '1.99',
    currency: 'EUR',
  },
  side: 'debit',

  afterCreate(accountEntry) {
    assert(
      accountEntry.transaction,
      `Missing 'transaction' relationship on 'accountEntry:${accountEntry.id}'`
    );

    assert(
      accountEntry.account,
      `Missing 'account' relationship on 'accountEntry:${accountEntry.id}'`
    );
  },
});
